import { useMutation, useQueryClient, type UseMutationOptions } from '@tanstack/react-query';
import { serviceApiV3 } from '@/api/client';
import { mediaBase } from './configs';
import type { CreateLinearJobRequest } from './live-linear-jobs-types';
import type { EventJob } from './live-event-jobs-types';
import { liveEventJobKeys } from './live-event-jobs';
import { liveLiveStreamKeys } from './live-live-streams';

// ============================================
// Mutations
// ============================================

/**
 * Create a linear (24/7) live-stream job.
 * Response shape is identical to EventJob — same provider model.
 */
export function useCreateLinearJob(
  serviceId: string,
  options?: UseMutationOptions<EventJob, Error, CreateLinearJobRequest>,
) {
  const qc = useQueryClient();
  return useMutation<EventJob, Error, CreateLinearJobRequest>({
    mutationFn: async (payload: CreateLinearJobRequest) => {
      const res = await serviceApiV3.post(`${mediaBase(serviceId, 'streams')}/linear`, payload);
      return res.data?.data ?? res.data;
    },
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: liveEventJobKeys.all });
      // New linear jobs surface in the Current Jobs (live streams) list.
      qc.invalidateQueries({ queryKey: liveLiveStreamKeys.all });
      options?.onSuccess?.(...args);
    },
  });
}
